import { TasksTypes } from '../hooks/useFilterType';

export const getIsActiveTypesFilter = (filters: TasksTypes[]) => {
    const isGanttTypes = filters.includes(TasksTypes.GANTT);
    if (filters.length === 3 && isGanttTypes) return true;
    if (filters.length === 3 && !isGanttTypes) return false;
    if (filters.length !== 3) return true;
};
